import { useState, useEffect } from 'react';
import { Quote } from 'lucide-react';
import { apiClient } from '../../contexts/AuthContext';

export function DailyQuoteCard() {
  const [quote, setQuote] = useState(null);

  useEffect(() => {
    apiClient.get('/coaching/daily-quote')
      .then(res => setQuote(res.data?.quote))
      .catch(() => {});
  }, []);

  if (!quote) return null;

  return (
    <div
      className="mt-3 relative overflow-hidden rounded-xl border border-[#FF6B35]/30 px-4 py-3"
      style={{
        background: 'linear-gradient(135deg, rgba(255,107,53,0.12) 0%, rgba(255,184,0,0.06) 55%, rgba(233,30,140,0.08) 100%)',
        boxShadow: '0 0 18px rgba(255,107,53,0.18), inset 0 1px 0 rgba(255,255,255,0.06)',
      }}
      data-testid="daily-quote-card"
    >
      <div
        className="pointer-events-none absolute -top-10 -right-6 w-28 h-28 rounded-full"
        style={{ background: 'radial-gradient(circle, rgba(255,184,0,0.22) 0%, transparent 70%)' }}
      />
      <div className="flex items-start gap-2.5">
        <Quote className="w-4 h-4 text-[#FFB800] shrink-0 mt-0.5 rotate-180" style={{ filter: 'drop-shadow(0 0 6px rgba(255,184,0,0.6))' }} />
        <div className="min-w-0">
          <p className="text-sm text-zinc-100 italic leading-relaxed" style={{ textShadow: '0 0 12px rgba(255,255,255,0.15)' }}>
            {quote}
          </p>
          <p className="text-[11px] font-bold mt-1.5 tracking-wide" style={{
            background: 'linear-gradient(90deg, #FF6B35, #FFB800)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}>— Coach Namaste</p>
        </div>
      </div>
    </div>
  );
}
